<template>
    <div>
        <span class="setting-header">Faktura</span>
        <div class="setting-group">
            <div class="setting">
                <Setting name="DEFAULT_INVOICE_DUE_DATE"/>
            </div>
            <div class="setting with-border">
                <Setting name="INVOICE_INCLUDE_PHONE"/>
            </div>
            <div v-if="invoiceIncludesPhoneNumber" class="setting with-border">
                <Setting name="INVOICE_SUPPLIER_PHONE" :validator="validatePhone"/>
            </div>
            <div class="setting with-border">
                <Setting name="INVOICE_INCLUDE_EMAIL"/>
            </div>
            <div v-if="invoiceIncludesEmail" class="setting with-border">
                <Setting name="INVOICE_SUPPLIER_EMAIL" :validator="validateEmail"/>
            </div>
        </div>
        <span class="setting-header">MVA</span>
        <div class="setting-group">
            <div class="setting">
                <Setting name="VAT_LIABLE"/>
            </div>
            <div v-if="isVatLiable" class="mt-1">
                <div class="setting with-border">
                    <Setting name="VAT_LIABLE_SINCE"/>
                </div>
                <div class="setting with-border">
                    <Setting name="VAT_ANNUALLY"/>
                </div>
            </div>
        </div>
        <span class="setting-header">Transaksjonsfelt</span>
        <div class="setting-group">
            <div class="setting">
                <Setting name="DEPARTMENT_REQUIRED"/>
            </div>

            <div class="setting with-border">
                <Setting name="PROJECT_REQUIRED"/>
            </div>

            <div class="setting with-border">
                <Setting name="DESCRIPTION_REQUIRED"/>
            </div>
        </div>
        <span class="setting-header">Annet</span>
        <div class="setting-group">
            <div class="setting">
                <Setting name="ONBOARDING_ORGANIZATION_COMPLETE"/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Setting from '@/setting/Setting.vue'
import {useSetting} from '@/setting/setting.service'
import {computed, ComputedRef} from 'vue'
import {emailRegex, phoneRegex} from '@/services/validators.service'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()


const validateEmail = (value: string | null | undefined) => {
    if (!value || value.trim() === '') return undefined
    return emailRegex.test(value) ? undefined : t('setting.validation.invalidEmail')
}

const validatePhone = (value: string | null | undefined)=> {
    if (!value || value.trim() === '') return undefined
    return phoneRegex.test(value) ? undefined : t('setting.validation.invalidPhoneNumber')
}

const {setting:vatLiableSetting} = useSetting<boolean>('VAT_LIABLE')
const {setting:invoiceIncludePhoneNumberSetting} = useSetting<boolean>('INVOICE_INCLUDE_PHONE')
const {setting:invoiceIncludeEmailSetting} = useSetting<boolean>('INVOICE_INCLUDE_EMAIL')

const isVatLiable: ComputedRef<Boolean> = computed<Boolean>(() => {
    const isVatLiableSetting = vatLiableSetting.value
    return isVatLiableSetting?.value ?? isVatLiableSetting?.default ?? isVatLiable.value
})

const invoiceIncludesEmail: ComputedRef<Boolean> = computed<Boolean>(() => {
    const invoiceShouldIncludeEmailSetting = invoiceIncludeEmailSetting.value
    return invoiceShouldIncludeEmailSetting?.value ?? invoiceShouldIncludeEmailSetting?.default ?? invoiceIncludesEmail.value
})

const invoiceIncludesPhoneNumber: ComputedRef<Boolean> = computed<Boolean>(() => {
    const invoiceShouldIncludePhoneNumberSetting = invoiceIncludePhoneNumberSetting.value
    return invoiceShouldIncludePhoneNumberSetting?.value ?? invoiceShouldIncludePhoneNumberSetting?.default ?? invoiceIncludesPhoneNumber.value
})

</script>

<style scoped>

</style>